import moment from "moment";
import React, { useState } from "react";
import { Button, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import TableActions from "../../../components/Common/TableActions";
import TableLayout from "../../../components/TableLayout";
import dataHandler from "../../../hooks/dataHandler";
import { GETBOOKING } from "../../../services/ApiCalls";
import {
  activeInactiveOptions,
  AdminStatusOptionSubscription,
  bookingStatus,
  BookingStatusOptions,
  orderStatusArr,
  paidUnpaidFilter,
} from "../../../utilities/const";
import {
  capitalizedFirstAlphaBet,
  exportCsvHandler,
  findLabelOfStatus,
} from "../../../utilities/utilities";
import Filter from "../../../components/Common/Filter";
import Toggle from "../../../components/Common/Toggle";
import ImportCsv from "../../../components/Common/ImportCsv";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import CountryFilter from "../../../components/Common/CountryFilter";

const OrderManagement = () => {
  const [userDetails, setUserUserDetails] = useState();
  const [exportLoader, setExportLoader] = useState();
  
  const [deleteModal, setDeleteModel] = useState();
  const {
    setBody,
    body,
    data,
    loader,
    paginationHandler,
    searchHandler,
    total,
  } = dataHandler({
    api: GETBOOKING,
  });
  const { id } = useParams();
  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => <>{key + 1}</>,
    },
    {
      head: "Booking ID",
      accessor: "bookingId",
      component: (item) => (
        <>
          <span className="d-block text-truncate">{item?.bookingId}</span>
        </>
      ),
    },
    { head: "Booking Type", accessor: "bookingType" },

    {
      head: "Price",
      accessor: "price",
      component: (item) => (
        <>{item?.price ? item?.currencySymbol + item?.price : "--"}</>
      ),
    },
    {
      head: "Discount",
      accessor: "discount",
      component: (item) => (
        <>{item?.discount ? item?.currencySymbol + item?.discount : "--"}</>
      ),
    },
    {
      head: "Final Price",
      accessor: "finalPrice",
      component: (item) => (
        <>{item?.finalPrice ? item?.currencySymbol + item?.finalPrice : "--"}</>
      ),
    },

    {
      head: "Hotel Name",
      accessor: "hotelName",
      component: (item) => <>{item?.hotelDetail?.hotelName || "-"}</>,
    },
    {
      head: "Hotel Id",
      accessor: "hotelId",
      component: (item) => <>{item?.hotelDetail?.hotelId || "-"}</>,
    },
    {
      head: "Payment Status",
      accessor: "paymentStatus",
      component: (item) => (
        <span className="text-capitalize">{item?.paymentStatus || "-"}</span>
      ),
    },

    {
      head: "User Name",
      accessor: "first_name",
      component: (item) => {
        const firstName = item?.customerDetail?.first_name || "";
        const lastName = item?.customerDetail?.last_name || "";
        const fullName = [firstName, lastName].filter(Boolean).join(" ");
        return <>{fullName || "-"}</>;
      },
    },

    {
      head: "Date & Time",
      accessor: "createdAt",
      component: (item) => (
        <>{moment(item?.createdAt).format("MM-DD-YYYY , HH:mm")}</>
      ),
    },

    {
      head: "Booking Status",
      accessor: "bookingStatus",
      component: (item) => {
        const status = item?.bookingStatus?.toLowerCase() || "";

        const statusStyles = {
          pending: {
            backgroundColor: "#fff3cd",
            color: "#856404",
          },
          completed: {
            backgroundColor: "#d4edda",
            color: "#155724",
          },
          rejected: {
            backgroundColor: "#f8d7da",
            color: "#721c24",
          },
          cancelled: {
            backgroundColor: "#e2e3e5",
            color: "#383d41",
          },
        };

        const style = statusStyles[status] || {
          backgroundColor: "#f0f0f0",
          color: "#333",
        };

        return (
          <span
            style={{
              ...style,
              borderRadius: "12px",
              padding: "4px 10px",
              display: "inline-block",
              fontWeight: "600",
              fontSize: "0.85rem",
              textTransform: "capitalize",
            }}
          >
            {status || "-"}
          </span>
        );
      },
    },

    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions viewLink={`/manage-booking/${item._id}?page=${body.page}`} />
      ),
    },
  ];

  console.log(data, "data=====<>");

  return (
    <>
      <section className="orderManagement position-relative py-2">
        <Container>
          <Row>
            <Col lg="12 ">
              <div className="d-flex  justify-content-between">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  Booking History
                </h4>
                <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Filter by Country
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    FilterPaidAndUnpaid={bookingStatus}
                    type="booking"
                  />
                </div>

                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("bookingcsv ", setExportLoader)
                        }
                      >
                        {exportLoader ? <ButtonLoader /> : "Export CSV"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="my-2">
                <Col lg="12" className="my-2">
                  <TableLayout column={column} data={data} loader={loader} />
                  <CustomPagination
                    total={total}
                    pageChangeHandler={paginationHandler}
                    body={body}
                    setBody={setBody}
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default OrderManagement;
